<div class="content">
  @if (products()[BillingPlanTier.Start]; as start) {
    <div [class.disabled]="viewMode() === ViewMode.StaffingAgency" class="column">
      <div class="heading">{{ 'app.pricing.start' | translate }}</div>
      <span>{{ 'app.pricing.plan_picker_2024.products.start_description_v2' | translate }}</span>
      @if (start.costPerMonth && start.costPerYear) {
        <div margin-top-auto>
          <div margin-top-large margin-bottom-small-x>
            {{ 'app.pricing.plan_picker_2024.products.fixed_price' | translate }}
          </div>
          <rt-plan-picker-2024-product-price
            [costPerMonth]="start.costPerMonth!"
            [costPerYear]="start.costPerYear!"
            [currency]="currency()"
            [interval]="interval()"
          />
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="getQuote" />
      }
      <rt-plan-button
        [disabled]="isButtonDisabled(start.status) || showSlotsLimitMessage()"
        (click)="chooseProduct.emit(start)"
        [hasIcon]="false"
        variant="start"
      >
        {{ start.status | rtPlanPickerProductCtaLabel }}
      </rt-plan-button>
    </div>
  }

  @if (products()[BillingPlanTier.Grow]; as grow) {
    <div [class.disabled]="viewMode() === ViewMode.StaffingAgency" class="column middle">
      <div [class.hidden]="viewMode() === ViewMode.StaffingAgency" class="highlight">
        {{ 'app.pricing.plan_picker_2024.products.most_popular' | translate }}
      </div>
      <div class="heading grow">
        {{ 'app.pricing.grow' | translate }}
        @if (showTrialBadge()) {
          <rt-badge
            margin-left-small-xx
            color="grow"
            [text]="'app.pricing.plan_picker.trial_plan' | translate"
          />
        }
      </div>
      <span>{{ 'app.pricing.plan_picker_2024.products.grow_description_v2' | translate }}</span>
      @if (grow.costPerMonth && grow.costPerYear) {
        <div margin-top-auto>
          <div margin-top-large margin-bottom-small-x>
            {{ 'app.pricing.plan_picker_2024.products.price' | translate }}
          </div>
          <rt-plan-picker-2024-product-price
            [costPerMonth]="grow.costPerMonth!"
            [costPerYear]="grow.costPerYear!"
            [currency]="currency()"
            [interval]="interval()"
          />
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="getQuote" />
      }
      <rt-plan-button
        [disabled]="isButtonDisabled(grow.status)"
        (click)="chooseProduct.emit(grow)"
        [hasIcon]="false"
        variant="grow"
      >
        {{ grow.status | rtPlanPickerProductCtaLabel }}
      </rt-plan-button>
    </div>
  }

  @if (products()[BillingPlanTier.Optimize]; as optimize) {
    <div class="column right">
      <div [class.hidden]="viewMode() !== ViewMode.StaffingAgency" class="highlight">
        {{ 'app.pricing.plan_picker_2024.products.for_agencies' | translate }}
      </div>
      <div class="heading optimize">{{ 'app.pricing.optimize' | translate }}</div>
      <span>{{ 'app.pricing.plan_picker_2024.products.optimize_description_v2' | translate }}</span>
      <ng-container *ngTemplateOutlet="getQuote" />
      <rt-plan-button
        [disabled]="isButtonDisabled(optimize.status)"
        (click)="chooseProduct.emit(optimize)"
        [hasIcon]="false"
        variant="optimize"
        >{{ optimize.status | rtPlanPickerProductCtaLabel }}
      </rt-plan-button>
    </div>
  }
</div>

<div class="content">
  <div [class.disabled]="viewMode() === ViewMode.StaffingAgency" class="below">
    @if (showSlotsLimitMessage()) {
      <rt-job-slots-limit-message
        [compact]="true"
        [altMessage]="
          'app.pricing.plan_picker_2024.archive_jobs_message'
            | translate: { count: startPlanSlotsLimit() }
        "
      />
    }
    @if (showCancelSubscription(products()[BillingPlanTier.Start].status)) {
      <span (click)="cancelSubscription.emit()" class="cancel">
        {{ 'app.pricing.plan_picker.cancel_subscription' | translate }}
      </span>
    }
    <rt-divider />
  </div>
  <div [class.disabled]="viewMode() === ViewMode.StaffingAgency" class="below middle">
    @if (showCancelSubscription(products()[BillingPlanTier.Grow].status)) {
      <span (click)="cancelSubscription.emit()" class="cancel">
        {{ 'app.pricing.plan_picker.cancel_subscription' | translate }}
      </span>
    }
    <rt-divider />
  </div>
  <div class="below">
    @if (showCancelSubscription(products()[BillingPlanTier.Optimize].status)) {
      <span (click)="cancelSubscription.emit()" class="cancel">
        {{ 'app.pricing.plan_picker.cancel_subscription' | translate }}
      </span>
    }
    <rt-divider />
  </div>
</div>

<ng-template #getQuote>
  <div margin-top-auto>
    <div margin-top-large margin-bottom-small-x>
      {{ 'app.pricing.plan_picker_2024.products.price_tailored' | translate }}
    </div>
    <div layout>
      <div class="price">
        {{ 'app.pricing.plan_picker_2024.products.get_a_quote' | translate }}
      </div>
    </div>
  </div>
</ng-template>
